import React from 'react';
import { useBranding } from '../hooks/useBranding';

/**
 * BrandingProvider component that applies tenant branding (colors and favicon)
 * when user is authenticated and branding is enabled.
 * Must be rendered inside EntitlementProvider to access user/tenant context.
 */
export const BrandingProvider = ({ children }) => {
  // Apply branding when user is authenticated
  useBranding();
  
  return <>{children}</>;
};
